// src/roomSidebarTabConfig.ts
import {
  FaCubes,
  FaCheckDouble,
  FaBalanceScale,
  FaExchangeAlt,
  FaInfoCircle,
  FaStreetView,
  FaCheck,
  FaHashtag,
  FaRegCommentDots,
} from "react-icons/fa";
import type { IconType } from "react-icons";
import { RoomSideBarTabs } from "@multiconsult-group/multiplacer-core";
import { FaBrain, FaClipboardList } from "react-icons/fa6";

export interface RoomSidebarTabConfig {
  label: string;
  tooltip: string;
  icon: IconType;
}

export const ROOM_SIDEBAR_TAB_CONFIG: Record<RoomSideBarTabs, RoomSidebarTabConfig> = {
  [RoomSideBarTabs.CEILING_MULTIPLACER_PRODUCTS]: {
    label: "Komponenter",
    tooltip: "Multiplacer-komponenter i rommet",
    icon: FaCubes,
  },
  [RoomSideBarTabs.CEILING_AI_PREDICTIONS]: {
    label: "AI-prediksjoner",
    tooltip: "AI-genererte prediksjoner for himlingen",
    icon: FaBrain,
  },
  [RoomSideBarTabs.ROOM_SECTION_VIEWS]: {
    label: "Seksjoner",
    tooltip: "Seksjonsvisninger for valgt rom",
    icon: FaStreetView,
  },
  [RoomSideBarTabs.CEILING_STANDARD_ROOM]: {
    label: "Standardrom",
    tooltip: "Standardrom",
    icon: FaBalanceScale,
  },
  [RoomSideBarTabs.CEILING_VALIDATIONS]: {
    label: "Himlingssjekk",
    tooltip: "Valideringer av himling og plasseringer",
    icon: FaCheck,
  },
  [RoomSideBarTabs.CEILING_COMMENTS]: {
    label: "Kommentarer",
    tooltip: "Kommentarer for himling",
    icon: FaRegCommentDots,
  },
  [RoomSideBarTabs.RFP_STANDARD_ROOM_DIFF]: {
    label: "Standardrom",
    tooltip: "Avvik mellom rom og standardrom",
    icon: FaExchangeAlt,
  },
  [RoomSideBarTabs.ROOM_SPECIFIED_ARTICLES]: {
    label: "Forekomster",
    tooltip: "Validering av programmerte artikler mot forekomster i dRofus",
    icon: FaClipboardList,
  },
  [RoomSideBarTabs.ROOM_NUMBERING_DETAILS]: {
    label: "Romnummerering",
    tooltip: "Detaljer for romnummerering",
    icon: FaHashtag,
  },
  [RoomSideBarTabs.ROOM_INFO]: {
    label: "Rominfo",
    tooltip: "Detaljert informasjon om valgt rom",
    icon: FaInfoCircle,
  },
  [RoomSideBarTabs.ROOM_DROFUS_CHANGES]: {
    label: "dRofus-endringer",
    tooltip: "dRofus-endringer i rommet",
    icon: FaExchangeAlt,
  },
};
